<template>
  <div class="company-examine-bd">
    <div class="header">
      <div class="center-content">
        <div class="icon"></div>
        <div class="title">{{$t('crm_renter_examine.zlfxxsh')}}</div>
      </div>
    </div>
    <div class="box">
      <div class="company-content">
        <!-- 基本信息 -->
        <div class="tip">
          <i class="icon icon-tishi"></i>
          <span>{{$t('crm_renter_examine.qzxhdyxzlfxx')}}</span>
        </div>
        <partner-examine-detail-base v-if="data.enterpriseType===1 || data.enterpriseType===2" :data="data" :partnerId="renterId">
        </partner-examine-detail-base>
        <partner-examine-detail-institutions v-if="data.enterpriseType===3" :data="data" :partnerId="renterId">
        </partner-examine-detail-institutions>
        <partner-examine-detail-religion v-if="data.enterpriseType===4" :data="data" :partnerId="renterId">
        </partner-examine-detail-religion>
        <partner-examine-detail-personal v-if="data.enterpriseType===5" :data="data" :partnerId="renterId">
        </partner-examine-detail-personal>
        <div class="base-item last">
          <div class="title">{{$t('crm_renter_examine.chuang_jian_xin_xi')}}</div>
          <div class="row">
            <div class="col">
              <div class="key">{{$t('crm_renter_examine.chuang_jian_gong_si')}}</div>
              <div class="val">{{ data.company }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_renter_examine.chuang_jian_ren')}}</div>
              <div class="val">{{ data.creator }}</div>
            </div>
            <div class="col">
              <div class="key">{{$t('crm_renter_examine.chuang_jian_shi_jian')}}</div>
              <div class="val">{{ $momentLocal(data.gmtCreate,'YYYY-MM-DD')}}</div>
            </div>
          </div>
        </div>
        <div class="tip">
          <i class="icon icon-tishi"></i>
          <span>{{$t('crm_renter_examine.hdysxxglxslfqwglzjsh')}}</span>
        </div>
        <div class="tenter-body">
          <div class="table-bd">
            <custom-table
              ref="table"
              type="checkbox"
              :data="similarList"
              height="100%"
              @input="selectionChange($event, 'tableSelect')"
              :loading="isLoading"
              :column="tableColumn"
              @filter="filterChange"
              @sort="sortChange"
            >
            </custom-table>
          </div>
        </div>
        <el-form
          class="form"
          :model="form"
          :inline="true"
          ref="form"
          label-width="120px"
          label-position="top"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('crm_renter_examine.spsftg')" prop="isApprove" :rules="rules.isApprove">
                <el-radio-group v-model="form.isApprove">
                  <el-radio :label="1">{{$t('crm_renter_examine.tong_guo')}}</el-radio>
                  <el-radio :label="0">{{$t('crm_renter_examine.bu_tong_guo')}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="24">
            <el-form-item label="审批是否通过:" prop="isApprove" :rules="rules.isApprove">
              <el-switch v-model="form.isApprove"></el-switch>
            </el-form-item>
            </el-col>-->
            <el-col :span="24">
              <el-form-item
                 :label="$t('crm_renter_examine.shen_pi_yi_jian')"
                prop="approveDesc"
                :rules="form.isApprove?[]:rules.approveDesc"
              >
                <el-input
                  :rows="3"
                  type="textarea"
                  v-model="form.approveDesc"
                  :placeholder="$t('crm_renter_examine.qtxbtgyy')"
                  style="width:900px;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="footer">
          <el-button @click="onCancel">
            {{$t('Common.com_close')}}
          </el-button>
          <el-button type="primary" @click="saveExamine">{{$t('Common.com_confirm')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partnerExamineDetailBase from './partner_examine_detail_base.vue';
import partnerExamineDetailInstitutions from './partner_examine_detail_institutions.vue';
import partnerExamineDetailReligion from './partner_examine_detail_religion.vue';
import partnerExamineDetailPersonal from './partner_examine_detail_personal.vue';

export default {
  name: 'renter_examine',
  components: {
    partnerExamineDetailBase,
    partnerExamineDetailInstitutions,
    partnerExamineDetailReligion,
    partnerExamineDetailPersonal
  },
  data() {
    return {
      companyId: '',
      data: {},
      // 相似租赁方
      // partnerOrgId: '',
      administratorsData: [],
      // 相似租赁方表格
      tableCode: 'renter_examine',
      tableSelect: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 2,
        pageNum: 1,
        partnerType: 'CS', // 租赁方customer
        partnerId: '',
        businessLicense: '',
      },
      totalRows: null,
      isLoading: false,
      similarList: [],
      // 联系人弹窗
      dialogVisible: false,
      dialogData: {},
      dialogModel: {},
      // 联系人组ID用户新增联系人
      bizId: '',
      renterId: '',
      // // 营业执照图片
      // visible: false,
      // // 法人身份证
      // visible2: false,
      form: {
        // 合作伙伴
        partnerId: '',
        partnerOrgId: '',
        adminId: '',
        isApprove: 1,
        approveDesc: '',
      },
    };
  },
  mounted() {
    // 获取id   有去获取详情 无就新增
    this.renterId = this.getJump('renterId');
    // 查询租赁费传自己ID
    this.formSearch.partnerId = this.renterId;
    // 获取详情
    this.getCompanyDetail();
    // 清除缓存
    this.clearKeepAlive('renter');
  },

  computed: {
    rules() {
      return {
        isApprove: [{ type: 'number', required: true, message: this.$t('crm_renter_examine.qxzsftg') }],
        approveDesc: [
          { required: true, message: this.$t('crm_renter_examine.qtxbtgyy') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        ],
      };
    },
  },
  methods: {
    // 获取售后公司详情
    getCompanyDetail: function () {
      if (!this.renterId) {
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.renterId, creatorInfo: true }).then(
        (res) => {
          if (res.code === 0) {
            this.data = res.data;
            // 营业执照
            this.formSearch.businessLicense = res.data.businessLicense;
            this.getSimilar();

            this.form.partnerId = res.data.partnerId;
            this.form.partnerOrgId = res.data.partnerOrgId;
          }
        }
      );
    },
    // 表格选中变更
    selectionChange: function (val, name) {
      if (val.length > 1) {
        this.$refs.table.$refs.tb1.clearSelection();
        const select = val.pop();
        this.$refs.table.$refs.tb1.toggleRowSelection(select);
        this[name] = [select];
        // this.name = [];
        // this[name] = val;
      } else {
        // this.name = [];
        this[name] = val;
      }
      this.setTopicCode();
    },
    // 租赁方
    getSimilar: function () {
      this.getTableColumn();
      this.getFuncView();
      this.getSimilarList();
    },
    getSimilarList: function () {
      this.$getJSON(`${apis.partnerSimilarCustomerPage}`, this.formSearch).then(
        (res) => {
          this.similarList = res.data.list;
          this.totalRows = res.data.total;
        }
      );
    },
    // 关联租赁方
    relation: function (row) {
      // console.log('row', row);
      const tips = this.$t('crm_renter_examine.nqdyglczlfm');

      this.$showConfirm(tips)
        .then(() => {
          const params = {};
          params.partnerId = this.renterId;
          params.assPartnerOrganId = row.partnerOrgId;
          this.$postJSON(apis.partnerSimilarCustomerLink, params).then(
            (res) => {
              if (res.code === 0) {
                this.$message({
                  message: this.$t('Common.com_handle_success'),
                  type: 'success',
                });
                this.getSimilarList();
              }
            }
          );
        })
        .catch(() => {});
    },

    // 提交审核结果
    saveExamine: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.tableSelect.length > 0) {
          const params = {};
          params.partnerId = this.renterId;
          params.assPartnerOrganId = this.tableSelect[0].partnerOrgId;
          this.$postJSON(apis.partnerSimilarCustomerLink, params).then(() => this.$postJSON(apis.partnerApproveCustomer, this.form)
          ).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.onCancel();
          });
        } else {
          this.$postJSON(apis.partnerApproveCustomer, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.onCancel();
          });
        }
      });
    },
    onCancel: function () {
      this.clearTagByKeep('renter_examine');
      const parentPath = this.getJump('parentPath');
      if (parentPath) {
        this.jump(parentPath, {}, true);
      } else {
        this.jump('/customer/renter', {}, true);
      }
    },
  },
};
</script>

<style lang="scss">
.company-examine-bd {
  position: relative;
  background-color: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .header {
    // height: 100px;
    background: linear-gradient(
      180deg,
      rgba(74, 186, 241, 1) 0%,
      rgba(61, 174, 230, 1) 100%
    );
    width: 100%;

    .center-content {
      height: 100px;
      width: 900px;
      margin: 0 auto;
      background-image: url("~@/images/layout/identification_header_bg.png");
      background-position: bottom;
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 36px;
    }

    .icon {
      $r: 32px;
      width: $r;
      height: $r;
      background-image: url("~@/images/layout/icon_qi.png");
      background-size: 100%;
      background-repeat: no-repeat;
      float: left;
      margin-left: 361px;
      // margin-top: 34px;
    }

    .title {
      font-size: 22px;
      color: #fff;
      line-height: 32px;
      float: left;
      margin-left: 14px;
      // margin-top: 34px;
      font-weight: 500;
      letter-spacing: 2px;
    }
  }
  .box {
    width: 900px;
    margin: 0 auto;
    .company-header {
      padding: 30px 0 38px 35px;
      height: 60px;
      box-sizing: content-box;
      background-color: #ffffff;
      width: 950px;
      margin: 0 auto;
      h3 {
        font-size: 26px;
        height: 40px;
      }
      p {
        color: #666666;
        font-size: 14px;
        height: 20px;
      }
      span {
        margin-right: 30px;
      }
    }
    .company-content {
      // min-height: 100%;
      height: 0;
      flex: 1;
      // background-color: #FFFFFF;
      .tip {
        margin: 24px 0 16px;
        background: rgba(13, 154, 224, 0.15);
        margin-bottom: 16px;
        padding-left: 10px;
        .icon {
          color: #0d9ae0;
          font-size: 12px;
          margin-right: 10px;
        }
        span {
          line-height: 32px;
          color: #6c757d;
          font-size: 12px;
        }
      }
      .base-item {
        background: #fafafa;
        font-size: 12px;
        padding-bottom: 24px;
        padding-left: 24px;
        border-bottom: 1px solid #eef2f8;
        &.last {
          border: 0;
        }
        // &:nth-child(n + 2) {
        //   margin-top: 7px;
        // }
        overflow: hidden;
        .title {
          color: #0d9ae0;
          font-weight: bold;
          line-height: 16px;
          margin-top: 24px;
        }
        .row {
          overflow: hidden;
          // display: flex;
          .col {
            float: left;
            width: 201px;
            // flex: 1;
            margin: 24px 16px 0 0;
            &.long {
              width: 100%;
            }
            .key {
              color: #98a6ad;
              line-height: 16px;
            }
            .val {
              margin-top: 8px;
              font-weight: bold;
              color: #495057;
            }
            .detail {
              color: #0d9ae0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

        .table-bd {
          margin-top: 24px;
        }
      }
      .form {
        margin-top: 24px;
      }
      .footer {
        margin-top: 16px;
        padding-top: 15px;
        border-top: 1px solid #eef2f8;
        text-align: center;
        margin-bottom: 76px;
      }
    }
  }
}
</style>
